
<template>
    <div class="container1">
		<div class="name-box">
			<div class="input-box">
				<span style="font-size:14px">客户名称：{{customerName}}</span>
			</div>
		</div>
		<div class="btn-pay-box">
			<span>支付方式：</span>
			<el-select
				collapse-tags
				size='mini'
				class="select-box"
				v-model="paymodes"
				multiple :disabled="isDisabled"
				placeholder="请选择支付方式"
				@change="changeMethod"
				:popper-append-to-body="true">
				<el-option
					v-for="(item, index) in cuspaymodes"
					:key="index"
					:label="item.name"
					:value="item.paymode">
				</el-option>
			</el-select>

			<span style="margin:0 10px">好友代付</span>
			<el-switch v-model="friendpay" :disabled="isDisabled" @change="otherPay" :active-color="$fxPrimaryColor" inactive-color="#dcdfe6"></el-switch>
			<span style="margin-left:10px">注：目前好友代付仅支持客户支付方式为微信支付、微企付、B2b门店助手-微信支付、B2b门店助手-银行转账</span>
		</div>
		<div class="btn-pay-box">
			<span>退款方式设置：</span>
		</div>
		<div class="table-box">
			<div class="table-row" style="background:  #f0f3fa;padding: 10px 20px;">
				<span style="width:50%;">支付方式</span>
				<span class="select-box2">退款方式</span>
			</div>
			<div v-for="(reitem) in cusrefundmodes" :key="reitem.paymode">
				<div class="table-row">
					<span style="width:50%;">{{reitem.name}}</span>
					<el-select v-model="reitem.refundmode" :disabled="!reitem.enabled" @change="changeWechatPaymodes(reitem.paymode,reitem.refundmode)" collapse-tags class="select-box2" size='mini' placeholder="请选择退款方式">
						<el-option
							v-for="(item, index) in refundmodes"
							:key="index"
							:label="item.name"
							:value="item.mode">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="tip-row">
				1、到账周期为D+0的，不支持退款原路返回<br>
				2、网关渠道为招行、中行时，支持退款原路返回，但退款资金到账时间有差异，为D+1到账
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'table-box',
	components: {
	},
	props: {
		id: String
	},
	data () {
		return {
			isDisabled: true,
			paymodes: [],
			cuspaymodes: [],
			cusrefundmodes: [],
			refundmodes: [],
			rmodes: [],
			AuthorityList: {
				'03_0001_0001_00': false,
				'03_0001_0002_00': false,
				'03_0001_0003_00': false,
				'03_0001_0004_00': false,
				'03_0001_0005_00': false,
				'03_0001_0006_00': false,
				'03_0001_0007_00': false,
				'03_0001_0008_00': false,
				'03_0001_0009_00': false,
				'03_0001_0010_00': false,
				'03_0001_0011_00': false
			},
			supplierconsumerid: '',
			buysyscodeid: '',
			friendpay: false
		}
	},
	created () {
		this.customerName = window.sessionStorage.getItem('customerName')
		this.getAuthority('03_0001_0000_00')
		this.tableReload()
	},
	methods: {
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					let add = window.sessionStorage.getItem('isCustomerAdd')
					if (add === 'true') {
						if (this.AuthorityList['03_0001_0005_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					} else {
						if (this.AuthorityList['03_0001_0003_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					}
				}
			})
		},
		changeMethod () {
			let list = []
			let has2 = this.paymodes.indexOf(2)
			let has6 = this.paymodes.indexOf(6)
			this.paymodes.forEach(item => {
				if (item === 2) {
					if (has2 > has6) {
						list.push(item)
					}
				} else if (item === 6) {
					if (has6 > has2) {
						list.push(item)
					}
				} else {
					list.push(item)
				}
			})
			this.paymodes = list
			let params = {
				id: window.sessionStorage.getItem('customerid'),
				paymodes: this.paymodes.join(','),
				name: this.customerName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/updateCustomerShopPayMode`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableReload()
				} else {
					this.$message.error(res.msg)
					this.tableReload()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		otherPay (e) {
			let params = {
				customerIds: [window.sessionStorage.getItem('customerid')],
				payByFriendFlag: e ? '1' : '0'
			}
			let changeData = {
				pre: { lineSelect14: { type: '1' } },
				cur: { lineSelect14: { type: '2', customerName: this.customerName, status: e ? '开启好友代付' : '关闭好友代付' } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/batchUpdateCustomerPayByFriendFlag`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success((e ? '开启' : '关闭') + '好友代付成功')
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		changeWechatPaymodes (type, mode) {
			let rmlist = []
			let obj = {}
			let params = {
				id: window.sessionStorage.getItem('customerid'),
				suppliercustomerid: this.supplierconsumerid,
				name: this.customerName,
				refundmodelist: rmlist
			}
			obj.mode = mode
			obj.paymode = type
			rmlist.push(obj)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/updatecustomerrefundpaymodenew`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功')
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		tableReload () {
			let params = {
				id: window.sessionStorage.getItem('customerid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/findcustomershoppaymodenew`,
				data: params
			}).then(res => {
				if (res.result) {
					// TODO 过滤拉卡拉全渠道-收银台
					this.cuspaymodes = res.data.cuspaymodes
						.filter(item => item.paymode !== 15)
						.map(item => {
							if (item.paymode === 14 && !item.name) {
								item.name = '拉卡拉全渠道-余额支付'
							}
							if (item.paymode === 15 && !item.name) {
								item.name = '拉卡拉全渠道-收银台'
							}
							if (item.paymode === 16 && !item.name) {
								item.name = '拉卡拉钱包余额'
							}
							return item
						})
					let list = []
					this.cuspaymodes.forEach(item => {
						if (item.selected) {
							list.push(item.paymode)
						}
					})
					this.paymodes = list
					this.cusrefundmodes = res.data.cusrefundmodes
					this.refundmodes = res.data.refundmodes
					this.supplierconsumerid = res.data.supplierconsumerid
					this.buysyscodeid = res.data.buysyscodeid
					this.friendpay = res.data.frindpayflag
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.container1{
	// min-width: 730px;
	width: 100%;
	flex-direction: column !important;
	height:calc(100% - 20px) ;
	overflow-y: auto;
	.name-box{
		padding-bottom :10px;
		margin-top :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		border-bottom 1px solid #dce2fd
		.input-box{
			padding-left:20px;
			text-align :left
			overflow-x :hidden
			margin-bottom:10px
		}
	}
	.search-box{
		padding-bottom :10px;
		margin-top :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		border-bottom 1px solid #dce2fd
		.input-box-btn{
			width :80px;
		}
		.input-box{
			text-align :left;
			padding-left:20px;
			width :280px;
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:150px;
				margin-right:10px;
			}
		}
	}
	.btn-pay-box{
		margin-top:30px;
		display :flex
		align-items: center;
		padding-left: 20px;
	}
	.table-box{
    width: 450px;
		margin-top: 30px;
		.table-row {
			display: flex;
			align-items: center
			justify-content: space-around;
			text-align: left;
			margin: 20px 20px;
			padding: 0 20px;
			.select-box2{
				width:50%;
				margin-right: 70px;
			}
		}
		.tip-row {
			color: red
			text-align: left;
			padding-left: 40px;
			font-size: 14px;
			line-height: 25px;
		}
	}
}

</style>
<style lang="stylus">
</style>
